import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import TldrNavDropdown from "./TldrNavDropdown";
import TldrOrgDropdown from "./TldrOrgDropdown";
import { isEqual } from "lodash";
import TldrNotificationDropdown from "../common/TldrNotificationDropdown";
import TldrHelpAndSupportMenu from "../common/TldrHelpAndSupportMenu";
import {
  Box,
  Button,
  Flex,
  HStack,
  Icon,
  IconButton,
  Tooltip,
} from "@chakra-ui/react";
import { FaChevronLeft, FaCrown, FaUserPlus } from "react-icons/fa";
import { ROOT } from "../../_utils/routes";
import { withTranslation } from "react-i18next";
import TldrTrialEndedModal from "../../TldrSettings/TldrBillingAndPayments/Modals/TldrTrialEndedModal";
import { isFreePlan, isFreePlanOrTrialEnded } from "../../_utils/isFreePlan";
import { analyticsTrackEvent, isWorkspaceOwner } from "../../_utils/common";
import TldrWorkspaceAddMembersModal from "./TldrWorkspaceAddMembersModal";
import TldrUpgradeSubscriptionModal from "./modals/TldrUpgradeSubscriptionModal";
import {
  inviteMembersFeatures,
  UPGRADE_PLAN_IMAGE_LINK,
} from "../../_utils/constants";

const navStyles = {
  background: "brand.grey-darker",
  boxShadow: "0 8px 16px 0 rgba(0, 0, 0, 0.5)",
  height: "50px",
  position: "sticky",
  top: 0,
  px: 4,
  display: ["none", "none", "none", "flex"],
  alignItems: "center",
  justifyContent: "space-between",
  zIndex: 105,
};

export class TldrNavbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: props.match.path,
      showConfirmation: false,
      showUpgradePlanModal: false,
      showWorkspaceAddMembersModal: false,
      showUpgradeSubscriptionModal: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (!isEqual(this.props, prevProps)) {
      this.setState({ selected: this.props.match.path });
    }
  }
  backToHome = () => {
    this.props.history.push(ROOT);
  };

  onInviteMembers = () => {
    if (isFreePlanOrTrialEnded(this.props.subscription?.subscribedPlan)) {
      this.setState({
        ...this.state,
        showUpgradeSubscriptionModal: true,
      });
    } else {
      this.setState({
        ...this.state,
        showWorkspaceAddMembersModal: true,
      });
    }
  };

  render() {
    // const { selectedOrg } = this.props.auth.payload;
    const { t } = this.props;
    const { canInviteMemberToWorkspace } = this.props.workspacePermissionChecks;
    const isFree = isFreePlan(this.props.subscription.subscribedPlan);
    const isOwner = isWorkspaceOwner(this.props.auth.payload.user);
    const content = (
      <>
        <Flex sx={navStyles}>
          <Box>
            {this.props.showBackBtn && (
              <IconButton
                icon={<FaChevronLeft />}
                variant="secondary"
                mr={4}
                onClick={this.backToHome}
                size="sm"
              />
            )}
            <TldrOrgDropdown />
            {isOwner && isFree && (
              <Button
                leftIcon={<Icon color="brand.primary" as={FaCrown} />}
                ml={4}
                size="sm"
                onClick={() => {
                  analyticsTrackEvent("upgradePlan");
                  this.setState({ showUpgradePlanModal: true });
                }}
              >
                {t("upgrade_btn")}
              </Button>
            )}
          </Box>
          <HStack>
            {canInviteMemberToWorkspace && (
              <Tooltip label={t("invite_members")} hasArrow>
                <IconButton
                  borderRadius="full"
                  onClick={this.onInviteMembers}
                  aria-label="Options"
                  icon={<FaUserPlus />}
                  variant="ghost"
                  size="sm"
                  fontSize="lg"
                />
              </Tooltip>
            )}
            <TldrHelpAndSupportMenu />
            <TldrNotificationDropdown />
            <TldrNavDropdown variant="full"></TldrNavDropdown>
          </HStack>
        </Flex>
        {this.state.showUpgradePlanModal ? (
          <TldrTrialEndedModal
            show={this.state.showUpgradePlanModal}
            onHide={() => this.setState({ showUpgradePlanModal: false })}
          />
        ) : null}
        {this.state.showWorkspaceAddMembersModal ? (
          <TldrWorkspaceAddMembersModal
            onHide={() =>
              this.setState({
                ...this.state,
                showWorkspaceAddMembersModal: false,
              })
            }
          />
        ) : null}
        {this.state.showUpgradeSubscriptionModal ? (
          <TldrUpgradeSubscriptionModal
            show={this.state.showUpgradeSubscriptionModal}
            featureList={inviteMembersFeatures}
            image={UPGRADE_PLAN_IMAGE_LINK}
            title={t("invite_member_feature_heading", {
              ns: "workspace",
            })}
            subtitle={t("invite_member_feature_description", {
              ns: "workspace",
            })}
            onHide={() =>
              this.setState({
                ...this.state,
                showUpgradeSubscriptionModal: false,
              })
            }
          />
        ) : null}
      </>
    );

    return <>{content}</>;
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  subscription: state.subscription,
  workspacePermissionChecks: state.permissions.workspacePermissionChecks,
});

TldrNavbar.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) => ({});

export default withTranslation(["navbar"])(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(TldrNavbar))
);
